import { AppBar, Box, Button, CssBaseline, Toolbar, Divider, Menu, MenuItem, ListItemText, Checkbox, IconButton, LinearProgress, Modal, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography, useTheme, alpha, } from "@mui/material"

// template
import CustomSnackbar from "../../../components/CustomSnackbar"
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox"
import CustomTableContainer from "../../../components/table/CustomTableContainer"
import { tokens } from "../../../theme/theme"

//config
import dayjs from "dayjs"
import React, { useState, useEffect } from "react"
import GlobalConfig from "../../../components/GlobalConfig"

// icons
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ListItemIcon } from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import Searchicon from '@mui/icons-material/Search';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';

// hooks and page services
import CreateDispatch from "./createDispatch"
import { useDespatchPlan } from "../../../hooks/useDespatchPlan"
import DespatchPlanFilter from "./DespatchPlanFilter"

const DispatchList = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const handleBackDashboard = () => {
        handleBackWinderMachineEntry();
    }

    const showError = (message, severity) => {
        setAlertMessage(message);
        setalertsevierity(severity);
        showSnackbar();
        return true;
    };

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [cono, setCono] = useState('');
    const [visibleDespatchPlan, setVisibleDespatchPlan] = useState(true);
    const [visibleCreateDespatchPlan, setVisibleCreateDespatchPlan] = useState(false);

    const [fromModule, SetfromModule] = useState('');
    const [fromSubModule, SetfromSubModule] = useState('');
    const [headerDespatchplan, SetheaderDespatchplan] = useState('New Despatch Plan');

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertsevierity, setalertsevierity] = useState('');

    let [FinancierYear, setFinancierYear] = useState(1);

    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);


    const [iConfirmationID, setiConfirmationID] = useState(0);
    const [iProductID, setiProductID] = useState(0);

    const { dispatchList, loadDespatchPlanList, loading } = useDespatchPlan({ FinancierYear, showError, });

    const [rowsConfirmedOrdersDespacth, setrowsConfirmedOrdersDespacth] = useState([]);
    const [rowsReelItems, setrowsReelItems] = useState([]);
    const [rowsSheetItems, setrowsSheetItems] = useState([]);
    const [rowsReelItemsFiltered, setrowsReelItemsFiltered] = useState([]);
    const [rowsSheetItemsFiltered, setrowsSheetItemsFiltered] = useState([]);
    const [plannedQtyData, setplannedQtyData] = useState([]);


    const [selectedStatus, setSelectedStatus] = useState('All');
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openFirst = Boolean(anchorElFirst);
    const openSecond = Boolean(anchorElSecond);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Despatch Plan');

    const [filters, setFilters] = useState({
        DespatchOrderNo: '',
        dateOnly: '',
        DespatchOrderStatus: '',
        TotalDPQty: '',

    });

    const showSnackbar = () => {
        setSnackbarOpen(true);
    };

    // Call when dates change
    const handleDateFilterChange = (key, date) => {
        if (key === "from") setFromDate(date);
        if (key === "to") setToDate(date);

        // run only when both dates are chosen
        if (key === "from" && date && ToDate) loadDespatchPlanList(date, ToDate, cono);
        if (key === "to" && date && FromDate) loadDespatchPlanList(FromDate, date, cono);
    };

  const handleCOChange = (e) => {
    setCono(e.target.value);
};



    const handleCreateDispatchPlans = () => {
        setSelectedRow([]);
        setVisibleCreateDespatchPlan(true);
        setVisibleDespatchPlan(false);
        SetfromModule('Despatch Plan List')

    };

    const updateTotalQty = (fdata, fdata3, GlobalReelRows, GlobalSheetRows) => {
        // Loop through each row in rowsConfirmedOrdersDespacth
        fdata.forEach(oRowItem => {
            // Initialize SIPlanned_Qty and ReelBundleCount to 0 for each row
            oRowItem.SIPlanned_Qty = 0;
            oRowItem.ReelBundleCount = 0;

            // Loop through each row in rowsSheetItems
            GlobalSheetRows.forEach(oRowSheet => {
                if (oRowSheet.SelectItem && oRowItem.SOrderConfirmationId === oRowSheet.ConfirmationOrderID && oRowItem.SProductID === oRowSheet.ProductID) {
                    oRowItem.SIPlanned_Qty += oRowSheet.QtyPlanned;
                    oRowItem.ReelBundleCount += 1;
                }
            });

            // Loop through each row in rowsReelItems
            GlobalReelRows.forEach(oRowReel => {
                if (oRowReel.SelectItem && oRowItem.SOrderConfirmationId === oRowReel.ConfirmationOrderID && oRowItem.SProductID === oRowReel.ProductID) {
                    oRowItem.SIPlanned_Qty += oRowReel.QtyPlanned;
                    oRowItem.ReelBundleCount += 1;
                }
            });

            // Round SIPlanned_Qty to 4 decimal places
            oRowItem.SIPlanned_Qty = Math.round(oRowItem.SIPlanned_Qty * 10000) / 10000;
        });

        // Assuming you want to update the state with the modified rowsConfirmedOrdersDespacth
        setrowsConfirmedOrdersDespacth([...fdata]);


        // Loop through each row in plannedQtyData
        fdata3.forEach(oRowQty => {
            // Initialize TotalQty to 0 for each row
            oRowQty.TotalQty = 0;

            // Loop through each row in rowsConfirmedOrdersDespacth
            fdata.forEach(oRowItem => {
                // Check if the ShipToCity and ShipToState match between the rows
                if (oRowQty.ShipToCity === oRowItem.ShipToCity && oRowQty.ShipToState === oRowItem.ShipToState) {
                    // If there's a match, update TotalQty by adding SIPlanned_Qty from the current row in rowsConfirmedOrdersDespacth
                    oRowQty.TotalQty += oRowItem.SIPlanned_Qty;
                }
            });
        });

        // Assuming you want to update the state with the modified plannedQtyData
        setplannedQtyData([...fdata3]);
    };

    const handleBackTofromDespacthPlanEntry = () => {
        setVisibleCreateDespatchPlan(false);
        setVisibleDespatchPlan(false);
        if (fromModule === 'Despatch Plan List') {
            setVisibleDespatchPlan(true);
            loadDespatchPlanList(FromDate, ToDate,);
        }

        else if (fromModule === 'Confirmed Orders') {
            setVisibleCreateDespatchPlan(true);
        }
        else if (fromSubModule === 'Despatch Plan Entry') {
            SetfromSubModule('');
        }
    };

    const handleBackTofromConnfrimOrderList = () => {
        setVisibleCreateDespatchPlan(false);
        setVisibleDespatchPlan(true);
    };

    useEffect(() => {
        loadDespatchPlanList(FromDate, ToDate);
    }, [FromDate, ToDate]);



    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);

        const updatedReelRows = rowsReelItems.map(row => {
            // Find the corresponding row in rowsSheetItemsFiltered
            const filteredRow = rowsReelItemsFiltered.find(filteredRow => filteredRow.id === row.id);

            // If the filtered row exists and matches the condition, update the SelectItem property
            if (filteredRow && filteredRow.id === row.id) {
                // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                return { ...row, SelectItem: filteredRow.SelectItem };
            } else {
                // If the filtered row doesn't exist or doesn't match, keep the row as it is
                return row;
            }
        });
        setrowsReelItems(updatedReelRows);

        const updatedsheetRows = rowsSheetItems.map(row => {
            // Find the corresponding row in rowsSheetItemsFiltered
            const filteredRow = rowsSheetItemsFiltered.find(filteredRow => filteredRow.id === row.id);

            // If the filtered row exists and matches the condition, update the SelectItem property
            if (filteredRow && filteredRow.id === row.id) {
                // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                return { ...row, SelectItem: filteredRow.SelectItem };
            } else {
                // If the filtered row doesn't exist or doesn't match, keep the row as it is
                return row;
            }
        });

        setrowsSheetItems(updatedsheetRows);
        updateReelStock();
        updateSheetStock();
        updateTotalQty(rowsConfirmedOrdersDespacth, plannedQtyData, rowsReelItemsFiltered, rowsSheetItemsFiltered);

    };

    const updateReelStock = () => {
        rowsReelItemsFiltered.forEach(oRow => {
            if (oRow.SelectItem) {
                if (headerDespatchplan.toLowerCase() === "New Despatch Plan" || headerDespatchplan.toLowerCase() === "Amended Despatch Plan") {
                    if (parseFloat(oRow.NoOfReelsPlanned) >= 0 && parseFloat(oRow.AvailableReels) >= 0 && parseFloat(oRow.NoOfReelsPlanned) > parseFloat(oRow.AvailableReels)) {
                        showError("Reels Planned cannot be more than " + oRow.AvailableReels.toString(), "error");
                        oRow.NoOfReelsPlanned = parseFloat(oRow.AvailableReels);
                    } else if (parseFloat(oRow.NoOfReelsPlanned) === 0) {
                        oRow.NoOfReelsPlanned = parseFloat(oRow.AvailableReels);
                    }
                    if (oRow.OrderRefNo === "SWO" && oRow.ProductID === iProductID) {
                        oRow.OrderID = iProductID;
                        oRow.ConfirmationOrderID = iConfirmationID;
                    }
                }
            } else if (oRow.OrderRefNo === "SWO" && oRow.ProductID === iProductID) {
                oRow.OrderID = 0;
                oRow.ConfirmationOrderID = 0;
            }
            let oLineQtyPlanned = 0;
            let oLineReelsPlanned = 0;
            let oLinePerReelWeight = 0;
            if (parseFloat(oRow.NoOfReelsPlanned) >= 0 && parseFloat(oRow.ReelWeight) >= 0) {
                oLineReelsPlanned = parseInt(oRow.NoOfReelsPlanned);
                oLinePerReelWeight = parseFloat(oRow.ReelWeight);
                oLineQtyPlanned = oLineReelsPlanned * oLinePerReelWeight; // / 1000
                oRow.QtyPlanned = Math.round(oLineQtyPlanned * 10000) / 10000;
            }
        });
        // Assuming you want to update the state with the modified rowsReelItemsFiltered
        setrowsReelItemsFiltered([...rowsReelItemsFiltered]);
    }


    const updateSheetStock = () => {
        rowsSheetItemsFiltered.forEach(oRow => {
            if (oRow.SelectItem) {
                if (headerDespatchplan.toLowerCase() === "New Despatch Plan" || headerDespatchplan.toLowerCase() === "Amended Despatch Plan") {

                    if (parseFloat(oRow.NoOfBundlesPlanned) >= 0 && parseFloat(oRow.AvailableBundles) >= 0 && parseFloat(oRow.NoOfBundlesPlanned) > parseFloat(oRow.AvailableBundles)) {
                        showError("Bundles Planned cannot be more than " + oRow.AvailableBundles.toString(), "error");
                        oRow.NoOfBundlesPlanned = parseFloat(oRow.AvailableBundles);
                    } else if (parseFloat(oRow.NoOfBundlesPlanned) === 0) {
                        oRow.NoOfBundlesPlanned = parseFloat(oRow.AvailableBundles);
                    }
                    if (oRow.OrderRefNo === "SWO" && oRow.ProductID === iProductID) {
                        oRow.OrderID = iProductID;
                        oRow.ConfirmationOrderID = iConfirmationID;
                    }
                }
            } else if (oRow.OrderRefNo === "SWO" && oRow.ProductID === iProductID) {
                oRow.OrderID = 0;
                oRow.ConfirmationOrderID = 0;
            }

            let oLineQtyPlanned = 0;
            let oLineBundlePlanned = 0;
            let oLinePerBundleWeight = 0;
            oLineBundlePlanned = parseInt(oRow.NoOfBundlesPlanned);
            oLinePerBundleWeight = parseFloat(oRow.WeightPerBundle);
            oLineQtyPlanned = oLineBundlePlanned * oLinePerBundleWeight; // / 1000
            oRow.QtyPlanned = Math.round(oLineQtyPlanned * 10000) / 10000;
        });

        // Assuming you want to update the state with the modified rowsSheetItemsFiltered
        setrowsSheetItemsFiltered([...rowsSheetItemsFiltered]);
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (FromDate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToDate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            loadDespatchPlanList(FromDate, ToDate, cono);
        }
    };



    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleKeyPress = (event) => {
        if (event.altKey && event.key.toLowerCase() === 'c') {
            handleCreateDispatchPlans();
        }
        if (event.altKey && event.key.toLowerCase() === 'p') {
            // handleBackTofromConnfrimOrderList();
        }
        if (event.altKey && event.key.toLowerCase() === 'n') {
            // handleShowDispatchPlansEntry();
        }
        if (event.altKey && event.key.toLowerCase() === 'b') {
            // handleBackTofromDespacthPlanEntry();
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleCreateDispatchPlans, handleBackTofromConnfrimOrderList, , handleBackTofromDespacthPlanEntry]);



    const DispatchData = dispatchList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.DespatchOrderStatus === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });




    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };
    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'New Despatch') {
            setSelectedStatus('New');
        }
        else if (option === 'Approved Despatch') {
            setSelectedStatus('Approved');
        }
        else if (option === 'Cancelled Despatch') {
            setSelectedStatus('Cancelled');
        }
        else if (option === 'Under Amendment Despatch') {
            setSelectedStatus('Under Amendment');
        }
        else if (option === 'Processed Despatch') {
            setSelectedStatus('Processed');
        }
        else if (option === 'All Despatch Plan') {
            setSelectedStatus('All');
        }

        setAnchorElFirst(null);
    };

    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        handleMenuCloseSecond();
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };

    const [selectedRow, setSelectedRow] = useState([]);
    const handleCallEdit = (value) => {
        setSelectedRow(value);
        setVisibleCreateDespatchPlan(true);
        setVisibleDespatchPlan(false);
    };

    const handleCallBack = () => {
        setVisibleCreateDespatchPlan(false);
        setVisibleDespatchPlan(true);
        loadDespatchPlanList(FromDate, ToDate);
    }

    return (<>
        <CssBaseline />
        {visibleDespatchPlan && (
            <>
                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "50px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        <Button
                            color="secondary"
                            onClick={handleMenuClickFirst}
                            endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                            sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                        >
                            {selectedOptionFirst}
                        </Button>
                        <Menu
                            anchorEl={anchorElFirst}
                            open={openFirst}
                            onClose={handleMenuCloseFirst}
                        >
                            <MenuItem onClick={() => handleMenuItemClickFirst('All Despatch Plan')}>All Despatch Plan</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('New Despatch')}>New Despatch</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Approved Despatch')}>Approved Despatch</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Cancelled Despatch')}>Cancelled Despatch</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Under Amendment Despatch')}>Under Amendment Despatch</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Processed Despatch')}>Processed Despatch</MenuItem>

                        </Menu>

                        {/* Adding margin-left: auto to push the button to the right */}
                        <Tooltip title="Confirmation Orders Availalbe for Despatch Plan [Alt + C]" >
                            <Button size="small" variant="contained" onClick={handleCreateDispatchPlans} color="secondary" startIcon={<AddIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New Despatch Plan</Button>
                        </Tooltip>

                        {/* Second Menu */}
                        <IconButton
                            size="small"
                            aria-label="menu"
                            sx={{ ml: 2 }}
                            onClick={handleMenuClickSecond}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            anchorEl={anchorElSecond}
                            open={openSecond}
                            onClose={handleMenuCloseSecond}
                        >
                            <MenuItem onClick={() => handleMenuItemClickSecond('Import Items')}>
                                <ListItemIcon>
                                    <ImportExportIcon />
                                </ListItemIcon>
                                <ListItemText primary="Import Items" />
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Items')}>
                                <ListItemIcon>
                                    <FileDownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Items" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                <ListItemIcon>
                                    <ViewColumnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Current View" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Preference " />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                <ListItemIcon>
                                    <RefreshIcon />
                                </ListItemIcon>
                                <ListItemText primary="Refresh List" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                    Reset Columns Width
                                </Button>
                            </MenuItem>
                        </Menu>

                        <IconButton
                            size="small"
                            aria-label="menu"
                            sx={{ mr: 1, ml: 1 }}
                            onClick={handleMenuClickSecond}
                        >
                            <HelpIcon />
                        </IconButton>

                        <div>
                            <IconButton>
                                <Close fontSize="inherit" style={{ color: "#2196F3" }} onClick={handleBackDashboard} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>

                <CustomSnackbar open={snackbarOpen} message={alertMessage} onClose={handleSnackbarClose} type={alertsevierity} />


                {loading && (
                    <Box sx={{ width: '100%', marginTop: '10px' }}>
                        <LinearProgress
                            variant="buffer"
                            sx={{
                                '& .MuiLinearProgress-barColorPrimary': {
                                    backgroundColor: '#4CAF50', // Green color (you can replace this with your desired color)
                                },
                                '& .MuiLinearProgress-bar2Buffer': {
                                    backgroundColor: '#8BC34A', // Another shade of green for the buffer
                                },
                            }}
                            value={progress}
                            valueBuffer={buffer}
                        />
                    </Box>
                )}

                <form onSubmit={handleSubmit}>
                    {/* <Box marginTop={2}> */}
                    <DespatchPlanFilter
                        fromDate={FromDate}
                        toDate={ToDate}
                        onFromChange={(date) => handleDateFilterChange("from", date)}
                        onToChange={(date) => handleDateFilterChange("to", date)}
                        autoFocus
                        containerProps={{}}
                        searchCO={cono}
                        onCOChange={handleCOChange}
                        handleSearch={handleSubmit}

                    />

                    <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '85vh', xl: '100vh' }}>
                        <CustomTableContainer colors={colors}>
                            <Table size="small">
                                <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                    <TableRow>
                                        <TableCell>DESPATCH PLAN #</TableCell>
                                        <TableCell>PLAN DATE</TableCell>
                                        <TableCell>PLAN STATUS</TableCell>
                                        <TableCell>PLANNED QUANTITY</TableCell>


                                        <TableCell>
                                            <IconButton onClick={handleOpen}>
                                                <Searchicon style={{ fontSize: "16px" }} />
                                            </IconButton>
                                            <Modal
                                                open={open}
                                                onClose={handleClose}
                                                aria-labelledby="modal-modal-title"
                                                aria-describedby="modal-modal-description"
                                            >
                                                <Box sx={{ position: 'absolute', top: '50%', left: '50%', bgcolor: 'background.paper', transform: 'translate(-50%, -50%)', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                    <TextField
                                                        label="DESPATCH PLAN NO"
                                                        name="DespatchOrderNo"
                                                        value={filters.DespatchOrderNo}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        size="small"
                                                        color="secondary"
                                                    />
                                                    <TextField
                                                        label="PLANNED DATE"
                                                        name="dateOnly"
                                                        value={filters.dateOnly}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        size="small"
                                                        color="secondary"
                                                    />
                                                    <TextField
                                                        label="PLAN STATUS"
                                                        name="DespatchOrderStatus"
                                                        value={filters.DespatchOrderStatus}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        size="small"
                                                        color="secondary"
                                                    />
                                                    <TextField
                                                        label="PLANNED QUANTITY"
                                                        name="TotalDPQty"
                                                        value={filters.TotalDPQty}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        size="small"
                                                        color="secondary"
                                                    />



                                                    <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                        Apply Filter
                                                    </Button>
                                                </Box>
                                            </Modal>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {DispatchData.map((row, index) => (
                                        <TableRow key={row.DespatchOrderId} sx={{
                                            backgroundColor: index % 2 === 0 ?
                                                theme.palette.background.default : alpha(theme.palette.action.hover, 0.04),
                                        }}>
                                            <TableCell>
                                                <span
                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                    onClick={() => handleCallEdit(row)}
                                                >
                                                    {row.DespatchOrderNo}
                                                </span>
                                            </TableCell>

                                           <TableCell>
    {dayjs(row.DespatchOrderDate).format("DD-MMM-YYYY")}
</TableCell>

                                            <TableCell>{row.DespatchOrderStatus}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.TotalDPQty}</TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </CustomTableContainer>
                    </ResponsiveBox>
                    {/* </Box> */}
                </form>
            </>)}

        {visibleCreateDespatchPlan && (
            <CreateDispatch handleBackTofromConnfrimOrderList={handleBackTofromConnfrimOrderList} selectedRow={selectedRow} handleCallBack={handleCallBack} />
        )}

    </>)
}
export default DispatchList